import { createSlice } from '@reduxjs/toolkit';

// Load initial state from localStorage
const loadState = () => {
  try {
    const storedState = localStorage.getItem('customizerState');
    
    // console.log( storedState ? JSON.parse(storedState) : undefined);
    return storedState ? JSON.parse(storedState) : undefined;
    
  } catch (e) {
    console.error('Failed to load state:', e);
    return undefined;
  }
};

const persistedLanguage = localStorage.getItem('i18nextLng') || 'en';

// Default initial state
const initialState = {
  language: persistedLanguage,
  topbarBg: 'gray-700',
  customizerSidebar: false,
  isRTL: false,
  isDark: false,
  isMiniSidebar: false,
  sidebarBg: 'white',
  isTopbarFixed: true,
  isMobileSidebar: false,
  isSidebarFixed: true,
  isLayoutHorizontal: false,
  isInnerRightPart: false,
};

// Create slice with persisted initial state
export const CustomizerSlice = createSlice({
  name: 'customizer',
  initialState: loadState() || initialState, // Use stored state or defaults
  reducers: {
    // Keep all existing reducers unchanged
    ChangeLanguage: (state, action) => {
      state.languageState = action.payload;
    },
    ChangeTopbarColor: (state, action) => {
      state.topbarBg = action.payload;
    },
    ToggleCustomizer: (state) => {
      state.customizerSidebar = !state.customizerSidebar;
    },
    ChangeDirection: (state, action) => {
      state.isRTL = action.payload;
    },
    ChangeDarkMode: (state, action) => {
      state.isDark = action.payload;
    },
    ToggleMiniSidebar: (state) => {
      state.isMiniSidebar = !state.isMiniSidebar;
    },
    ChangeSidebarColor: (state, action) => {
      state.sidebarBg = action.payload;
    },
    ToggleTopbar: (state, action) => {
      state.isTopbarFixed = action.payload;
    },
    ToggleMobileSidebar: (state) => {
      state.isMobileSidebar = !state.isMobileSidebar;
    },
    FixedSidebar: (state) => {
      state.isSidebarFixed = !state.isSidebarFixed;
    },
    ToggleHorizontal: (state) => {
      state.isLayoutHorizontal = !state.isLayoutHorizontal;
    },
    ToggleInnerRightPart: (state) => {
      state.isInnerRightPart = !state.isInnerRightPart;
    },
  },
});

// Middleware to save state changes to localStorage
const saveStateMiddleware = (store) => (next) => (action) => {
  const result = next(action);
  // console.log('Result: ');
  
  // console.log(result);
  
  if (action.type?.startsWith('customizer/')) {
    const state = store.getState().customizer;
    localStorage.setItem('customizerState', JSON.stringify(state));
  }
  return result;
};

export const {
  ChangeLanguage,
  ChangeTopbarColor,
  ToggleCustomizer,
  ChangeDirection,
  ChangeDarkMode,
  ToggleMiniSidebar,
  ChangeSidebarColor,
  ToggleTopbar,
  ToggleMobileSidebar,
  FixedSidebar,
  ToggleHorizontal,
  ToggleInnerRightPart,
} = CustomizerSlice.actions;

// Export the middleware to be added to the store
export const customizerMiddleware = saveStateMiddleware;

export default CustomizerSlice.reducer;